/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by richardwilliams on 3/25/15.
 */

'use strict';
angular
.module('prism-ui.components', ['reachEngine.authentication',
	'reachEngine.user',
	'prism-ui.components.branding',
	'prism-ui.components.data',
	'prism-ui.components.filters',
	'prism-ui.components.navigation',
	'prism-ui.externalMetadata',
	'prism-ui.system',
	'ui.grid.edit',
	'ui.grid.autoResize',
	'ui.grid.selection',
	'angularMoment',
    'ngSanitize',
	'com.2fdevs.videogular',
	'com.2fdevs.videogular.plugins.controls',
	'com.2fdevs.videogular.plugins.overlayplay',
	'com.2fdevs.videogular.plugins.poster'])
.constant('_', window._)
.constant('Rx', window.Rx)
.constant('X2JS', window.X2JS)
.constant('AW4', window.AW4)
.constant('AWS', window.AWS);
